import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { AuthService } from '../../shared/services/http/auth.service';

@Injectable({
  providedIn: 'root',
})
export class AdminAuthGuardService implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    const hasRole = this.authService.hasBackofficeRole();

    if (!hasRole) {
      sessionStorage.setItem('returnUrl', state.url);
      this.router.navigate(['/auth/login']);
    }
    return hasRole;
  }
}
